import React, { useContext, useState } from 'react'
import toast from 'react-hot-toast';
import { AllCommentsContext } from '../context/allComentsContext';
const useFormReply = (parentId: number| null,setDisplayNewReply:Function) => {
    const { addComment } = useContext(AllCommentsContext);
    const [email, setEmail] = useState("");
    const [reply, setReply] = useState("");
    const handleForm = async (event:React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if(email==="" ||  reply ===''){
            return toast.error('You need to fill all the fields');
        }
        await addComment(email,reply,parentId);
        setEmail("");
        setReply("");
        setDisplayNewReply(false);
        return toast.success('New reply added');
    }
    return {
        email,setEmail,reply,setReply,handleForm
    }
}

export default useFormReply